<template>
    <el-autocomplete
        class="inline-input group-input"
        size="large"
        placeholder="请输入完整的公司中文名，大于4个汉字"
        v-model="nameModel"
        :fetch-suggestions="querySearchGroup"
        :trigger-on-focus="false"
        @select="handleSelect">
        <template slot-scope="{ item }">
            <div class="name">
                {{ item.value }}
                （<span class="primary">{{item.userNumber}}</span>人）
                <span class="fr" style="text-decoration: underline;">点击加入</span>
            </div>
        </template>
    </el-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    model: {
        prop: 'name',
        event: 'change'
    },
    props: ['name', 'gid'],
    data() {
        return {
        }
    },
    computed: {
        nameModel: {
            get: function() {
                return this.name;
            },
            set: function(val) {
                this.$emit('change', val);
            }
        }
    },
    methods: {
        ...mapActions('group', ['getList']),
        async querySearchGroup(queryString, cb) {
            let list = [];
            try {
                let res = await this.getList(queryString);
                list = res.length ? res.map(item => {
                    item.value = item.name;
                    return item;
                }) : [];
            } catch (err) {
            }
            cb(list);
        },
        async validate(isEdit) {
            let name = this.nameModel || '';
            if (!name) { // 不能为空
                throw '内容不能为空';
            } else if (new RegExp('[^\u4e00-\u9fa5]').test(name)) { // 禁止输入中文以外的字符
                throw '只能输入中文';
            } else if (!isEdit && name.length < 4) { // 至少4个汉字
                throw '至少4个中文汉字';
            }
        },
        handleSelect(item) {
            this.$emit('update:gid', item._id);
            this.$emit('select', item);
        }
    }
}
</script>

<style lang="scss" scoped>
    .group-input {
    }
</style>



// WEBPACK FOOTER //
// app/components/CompanyGroupInput.vue